import { render, staticRenderFns } from "./AccountingBuildingsView.vue?vue&type=template&id=15c6849c&scoped=true"
import script from "./AccountingBuildingsView.vue?vue&type=script&lang=js"
export * from "./AccountingBuildingsView.vue?vue&type=script&lang=js"
import style0 from "./AccountingBuildingsView.vue?vue&type=style&index=0&id=15c6849c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6849c",
  null
  
)

export default component.exports